import {FC} from 'react'
import ProductImage from 'app/components/products/ProductImage'
import truncate from 'lodash/truncate'
import clsx from 'clsx'
import {simpleCurrency} from 'app/format/currency'
import FulfillmentStatus from 'app/features/orders/list/components/FulfillmentStatus'

type Props = {
  order: any
  isShowStatus?: boolean
}
const ProductListItem: FC<Props> = ({order, isShowStatus}) => {
  return (
    <tr>
      <td>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px me-3'>
            <ProductImage product={order.product} />
          </div>
          <div className='d-flex justify-content-start flex-column'>
            <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
              {truncate(order.product?.name, {length: 50})}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7'>
              {order.variant && order.variant.name ? order.variant.name : order.variant}
            </span>
          </div>
        </div>
      </td>
      {isShowStatus && (
        <td>
          <FulfillmentStatus status={order.status} />{' '}
        </td>
      )}
      <td>
        <div className='d-flex flex-column'>
          <span
            className={clsx(
              'text-dark fs-7 fw-bolder',
              order.discountPrice > 0 && 'text-decoration-line-through'
            )}
          >
            <div className='d-flex flex-column'>
              {order.originalPrice > 0 && order.price != order.originalPrice && (
                <s className='text-danger fw-bold'>{simpleCurrency(order.originalPrice)}</s>
              )}
              <p>{simpleCurrency(order.price)}</p>
            </div>
          </span>
          {order.discountPrice > 0 && (
            <span className='fw-bolder fs-7 text-gray-800 '>
              {simpleCurrency(order.discountPrice)}
            </span>
          )}
        </div>
      </td>
      <td className='text-dark fs-7 fw-bolder'>{order.quantity}</td>
      <td className='text-end text-dark fs-7 fw-bolder'>{simpleCurrency(order.totalPrice)}</td>
    </tr>
  )
}
export default ProductListItem
